"use client";

import ProductRecommendationCarousel from "../ProductRecommendationCarousel/ProductRecommendationCarousel";
import useGetViewedItemsFromLocalStorage from "@/hooks/useGetViewedItemsFromLocalStorage";

const RecentlyViewedCarousel = ({ id }: { id: number }) => {
	const { items } = useGetViewedItemsFromLocalStorage(id);

	// if (!items || !items.length) return null;

	return (
		<ProductRecommendationCarousel
			placementProductId={String(id)}
			searchSpringId='recently-viewed'
			products={items}
			title='Recently Viewed'
			useProductCards
			isLoading={false}
		/>
	);
};

export default RecentlyViewedCarousel;
